import { render, staticRenderFns } from "./BotaoAcao.vue?vue&type=template&id=3db13549&scoped=true&"
import script from "./BotaoAcao.vue?vue&type=script&lang=js&"
export * from "./BotaoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db13549",
  null
  
)

export default component.exports